import React, { useState, useEffect } from 'react'
import { Table, Row, Col, Grid, Avatar, Uploader, Icon, Loader, ButtonGroup } from 'rsuite'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import * as COLOR from '../../../constants/color'
import {
  downlondDocument,
  removeDocumentFile,
  downlondCoverFile,
  saveReviewerSendDate,
} from '../../../redux/actions/reviewSummary'
import { startLoading, doneLoading } from '../../../utils/loading'
import notification from '../../../utils/notification'
import { API_ROOT } from '../../../config/config'
import { downloadFile } from '../../../utils/fileUtil'
import ConfirmWidget from '../../../widgets/confirm/ConfirmWidget'
import TooltipButton from '../../buttons/TooltipButton'
import './styles.less'
import EditDateCell from '../../cell/EditDateCell'
import { useForm } from 'react-hook-form/dist/index.ie11'
import SaveButton from '../../buttons/saveButton/SaveButton'
import EditButton from '../../buttons/editButton/EditButton'
import CancelButton from '../../buttons/cancelButton/CancelButton'
import { DEFAULT_ERR_MSG, DELETE_FILE_SUCCESS_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import moment from 'moment'

const { Column, HeaderCell, Cell } = Table

export default function ApprovedExpertListTable({
  data,
  hideRound,
  hideIsSentProposalFilterDocument,
  hideSentDate,
  hideUploadDocumentColumn,
  hideUploadDocumentCommand,
  hideInviteLetter,
  setIsEnableSubmit = () => {},
  setIsAlertMessage = () => {},
  enableEdit,
}) {
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const [tableData, setTableData] = useState(data)
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [deleteData, setDeleteData] = useState()
  const [accessToken, setAccessToken] = useState()
  const [isEdit, setIsEdit] = useState(false)

  const { register, handleSubmit, errors, control, setValue, getValues, setError, clearErrors } =
  useForm()

  useEffect(() => {
    const _accessToken = localStorage.getItem('access_token')
    setAccessToken(_accessToken)
  }, [])

  const setRowData = (id, newData) => {
    setTableData((state) => {
      return state.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            ...newData,
          }
        }
        return item
      })
    })
  }

  const handleOnDownloadFile = async (id, fileName) => {
    startLoading()
    try {
      const file = await downlondDocument(projectId, id)
      downloadFile(file, fileName)
    } catch (err) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  const handleOnRemoveFile = (id, name) => {
    setDeleteData({
      id,
      name,
    })
    setIsShowConfirmDelete(true)
  }

  const handleOnConfirmDelete = async () => {
    setIsShowConfirmDelete(false)
    const { id } = deleteData
    startLoading()
    setRowData(id, {
      isRemoving: true,
    })
    try {
      const response = await removeDocumentFile({
        projectVersionId: projectId,
        projectReviewerId: id,
      })

      if(response){

        if(response?.model?.forms?.ReviewerApproveList?.itemsList?.length > 0){
          setTableData(response?.model?.forms?.ReviewerApproveList?.itemsList)  
        }

        //set Validate Review Summary for submit
        setIsEnableSubmit(response?.model?.forms?.ValidateResult?.enableSubmit)
        setIsAlertMessage(response?.model?.forms?.ValidateResult?.message)

        notification.open('success', {
          title: DELETE_FILE_SUCCESS_MSG,
        })
      }
      
      // setRowData(id, {
      //   fileLabel: null,
      //   fileName: null,
      //   filePath: null,
      //   isRemoving: false,
      // })

    } catch (err) {
      notification.open('error', {
        title: 'ลบเอกสารไม่สำเร็จ',
      })
    }
    setRowData(id, {
      isRemoving: false,
    })
    doneLoading()
  }

  const handleOnDownloadCoverFile = async (id, fileName, filePath) => {
    startLoading()
    try {
      const file = await downlondCoverFile(projectId, id)
      downloadFile(file, fileName)
    } catch (err) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  const handleOnSaveSendDate = async (request) => {
    startLoading()
    try {
      const response = await saveReviewerSendDate(projectId, request)

      if(response){
        setIsEdit(false)
        setTableData(response?.model?.forms?.ReviewerApproveList?.itemsList)

        //set Validate Review Summary for submit
        setIsEnableSubmit(response?.model?.forms?.ValidateResult?.enableSubmit)
        setIsAlertMessage(response?.model?.forms?.ValidateResult?.message)
      }
      
      notification.open('success', {
        title: SAVE_SUCCESS_MSG,
      })

    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errors?.message 
        || e?.response?.data?.errorMessage 
        || DEFAULT_ERR_MSG,
      })
    }
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('onSubmit', data)

    var dateList = Object.keys(data.table).map((key) => {
      return {
        id: key,
        sendDate: data.table[key] ? `${data.table[key].toLocaleDateString('en-CA')}T00:00:00.000Z` : null,
        sendDateString: data.table[key] ? data.table[key].toLocaleDateString('en-CA') : null,
      }
    })

    var request = {
      projectVersionId: projectId,
      itemsList: dateList
    }

    handleOnSaveSendDate(request)
  }

  const ImageCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props} style={{ padding: 0 }} align="center">
        <Grid fluid>
          <Icon icon="user" size="2x" style={{ marginTop: 10 }} />
          {/* rowData[dataKey] = https://image.flaticon.com/icons/png/512/149/149071.png   url นี้ไม่มีรูปภาพแล้ว */}
          {/* <Row>
          <Col
            lg={12}
            // style={
            //   {
            //     width: 40,
            //     height: 40,
            //     borderRadius: 20,
            //     marginTop: 2,
            //   }
            // }
          >
            <div style={{ marginTop: 6, marginLeft: 8 }}>
            <img src={rowData[dataKey]} width="35" />
            </div>
          </Col>
        </Row> */}
        </Grid>
      </Cell>
    )
  }

  const TagCell = ({ rowData, dataKey, descKey, ...props }) => {
    const color = rowData[dataKey] ? COLOR.TABLE_APPROVE_TAG_COLOR : COLOR.TABLE_UNAPPROVE_TAG_COLOR

    return (
      <Cell {...props} style={{ padding: 0, marginTop: 10 }}>
        <Row>
            {rowData[descKey] && (
              <Avatar
                style={{
                  //marginLeft: 20,
                  alignItems: 'center',
                  backgroundColor: color,
                  width: 100,
                  fontSize: 15,
                  height: 30,
                }}
              >
                {rowData[descKey]}
              </Avatar>
            )}
        </Row>
      </Cell>
    )
  }

  return (
    <div className="approve-expert-list-table">
      <Table
        wordWrap
        // height={tableData?.length > 0 ? 400 : 60}
        height={400}
        data={tableData}
        autoHeight={tableData?.length <= 5}
      >
        <Column width={60} align="center" fixed="left">
          <HeaderCell>
            <span></span>
          </HeaderCell>
          <ImageCell dataKey="avartar" />
        </Column>

        <Column minWidth={200} flexGrow={1} fixed="left">
          <HeaderCell>
            <span>ชื่อผู้ทรงคุณวุฒิ</span>
          </HeaderCell>
          <Cell>
            {(rowData, index) => {
              return `${index >= 0 ? index + 1 : ''}. ` + rowData.name || rowData.firstName
            }}
          </Cell>
        </Column>
        {!hideSentDate && (
          <Column width={180} align="center">
            <HeaderCell>
              <span>วันที่รับข้อคิดเห็น</span>
            </HeaderCell>
            <Cell>
              {(rowData, index) => {
                // if(!isEdit){
                //   return <span>{rowData.sentDate ? moment(rowData.sentDate, 'YYYY-MM-DD').toDate().toLocaleDateString('th-TH') : ''}</span>
                // }
                return <EditDateCell
                      id={`table[${rowData.id}]`}
                      rowData={rowData}
                      dataKey="sentDate"
                      register={register}
                      control={control}
                      errors={errors}
                      isEdit={rowData.isOnline ? false : isEdit} //isOnline ไม่เปิดให้แก้ไข
                      // startDate={_startProjectDate}
                      // endDate={_endProjectDate}
                      // defaultDate={defaultDate}
                      defaultDate={rowData.sentDate ? moment(rowData.sentDate, 'YYYY-MM-DD').toDate() : null}
                      rules={{required: null}}
                    />
              }}
            </Cell>

          </Column>
        )}
        {!hideUploadDocumentColumn && (
          <Column width={155} align="center">
            <HeaderCell>
              <span>แบบกลั่นกรอง</span>
            </HeaderCell>
            <Cell>
              {(rowData) => {
                if (
                  hideUploadDocumentCommand ||
                  !rowData.isApproved ||
                  (rowData.isOnline && !rowData.filePath)
                ) {
                  return null
                } else if (rowData.filePath) {
                  return (
                    <>
                      <ButtonGroup>
                        <TooltipButton
                          icon="download"
                          tooltip={`ดาวน์โหลด`}
                          disabled={rowData.isRemoving}
                          onClick={() => handleOnDownloadFile(rowData.id, rowData.fileName)}
                          iconClass={(!rowData.isOnline && !hideUploadDocumentCommand) ? "bt-gost-icon-radius" : "bt-gost-icon-radius-all"}
                        ></TooltipButton>
                        {!rowData.isOnline && !hideUploadDocumentCommand && (
                          <TooltipButton
                            icon="trash-o"
                            tooltip={`ลบ`}
                            disabled={rowData.isRemoving}
                            onClick={() => handleOnRemoveFile(rowData.id, rowData.name)}
                            iconClass="bt-gost-icon-radius-cancel-end"
                          ></TooltipButton>
                        )}
                      </ButtonGroup>
                    </>
                  )
                } else {
                  // const API_ROOT2 = 'http://localhost/api'
                  return (
                    <>
                      {rowData.isLoading && <Loader backdrop center />}
                      <Uploader
                        style={rowData.isLoading ? { display: 'none' } : {}}
                        accept=".jpg, .jpeg, .png, .pdf"
                        headers={{ Authorization: `Bearer ${accessToken}` }}
                        multiple={false}
                        fileList={rowData.isLoading ? [] : rowData.fileList}
                        onChange={(fileList) => {
                          setRowData(rowData.id, {
                            localFileList: fileList,
                          })
                        }}
                        onUpload={() => {
                          setRowData(rowData.id, {
                            isLoading: true,
                          })
                        }}
                        onSuccess={(response) => {
                          console.log('onSuccess', response)
                          if(response?.model?.forms?.ReviewerApproveList?.itemsList?.length > 0){
                            setTableData(response.model.forms.ReviewerApproveList.itemsList)

                            //set Validate Review Summary for submit
                            setIsEnableSubmit(response?.model?.forms?.ValidateResult?.enableSubmit)
                            setIsAlertMessage(response?.model?.forms?.ValidateResult?.message)

                            notification.open('success', {
                              title: SAVE_SUCCESS_MSG,
                            })
                          }

                          
                          
                          // if(response?.model?.forms?.UploadFileResult){
                          //   let uploadFileResult = response.model.forms.UploadFileResult
                          //   setRowData(rowData.id, {
                          //     fileLabel: uploadFileResult.label,
                          //     fileName: uploadFileResult.name,
                          //     filePath: uploadFileResult.path,
                          //     isLoading: false,
                          //     localFileList: [],
                          //   })
                          // }
                          
                        }}
                        onError={() => {
                          setRowData(rowData.id, {
                            isLoading: false,
                            localFileList: [],
                          })
                          notification.open('error', {
                            title: 'แนบเอกสารไม่สำเร็จ',
                          })
                        }}
                        listType="picture"
                        action={`${API_ROOT}/review/${projectId}/review-summary-file`}
                        name="Files"
                        data={{
                          ProjectReviewerId: rowData.id,
                        }}
                      >
                        <button className="upload__button">
                          <Icon icon="upload" size="lg" />
                        </button>
                      </Uploader>
                    </>
                  )
                }
              }}
            </Cell>
          </Column>
        )}
        {!hideRound && (
          <Column width={115} align="center">
            <HeaderCell>
              <span>รอบที่</span>
            </HeaderCell>
            <Cell dataKey="round" />
          </Column>
        )}
        <Column width={170} align="center">
          <HeaderCell>
            <span>วันที่ส่งพิจารณา</span>
          </HeaderCell>
          <Cell dataKey="sendConsiderDate" />
        </Column>
        <Column width={120} align="center">
          <HeaderCell>
            <span>วันที่อนุมัติ</span>
          </HeaderCell>
          <Cell dataKey="approvedReviewerDate" />
        </Column>
        <Column width={170} align="center">
          <HeaderCell>
            <span>ผลการพิจารณา</span>
          </HeaderCell>
          <TagCell dataKey="isApproved" descKey="approvedReviewerDesc" />
        </Column>
        {!hideIsSentProposalFilterDocument && (
          <Column width={100} align="center">
            <HeaderCell>
              <span>สถานะ</span>
            </HeaderCell>
            <TagCell
              dataKey="isSentProposalFilterDocument"
              descKey="sentProposalFilterDocumentDesc"
            />
          </Column>
        )}
        {!hideInviteLetter && (
          <Column width={130} align="center">
            <HeaderCell>
              <span>หนังสือเชิญ</span>
            </HeaderCell>
            <Cell>
              {(rowData) => {
                if (rowData.isApproved)
                  return (
                    <TooltipButton
                      icon="download"
                      tooltip={`ดาวน์โหลด`}
                      disabled={rowData.isRemoving}
                      onClick={() =>
                        handleOnDownloadCoverFile(
                          rowData.id,
                          rowData.coverFileName,
                          rowData.coverFilePath
                        )
                      }
                      iconClass="bt-gost-icon-radius-all"
                    />
                  )
              }}
            </Cell>
          </Column>
        )}
      </Table>
      <ConfirmWidget
        title={`ยืนยันการลบแบบกลั่นกรอง`}
        show={isShowConfirmDelete}
        detail={`ยืนยันการลบแบบกลั่นกรอง ${deleteData?.name}`}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={handleOnConfirmDelete}
      />

      <hr />

      {enableEdit && (
      isEdit ? (
        <>
          <SaveButton onClick={handleSubmit(onSubmit)}>
            บันทึกวันที่รับข้อคิดเห็น
          </SaveButton>
          <CancelButton
            onClick={() => {
              setIsEdit(false)
            }}
          >
            ยกเลิก
          </CancelButton>
        </>
      ) : (
        <EditButton onClick={() => setIsEdit(true)}>แก้ไขวันที่รับข้อคิดเห็น</EditButton>
      )
    )}
      

    </div>
  )
}
